import { EmployeesAndYears } from "../../../../models/pending-approvals/employees-tna-counters.filter";
import { TnAAbsenceDTO } from "../../../../models/tna";
import { ICountersPerEmployee, IOverlappingAbsences } from "./interfaces";
import { TnACounterDTO } from "../../../../models/tna/tna-counters/tna-counter-dto";
import { OverlappingAbsenceDTO } from "../../../../models/tna/tna-overlapping-absences/tna-overlapping-absence-dto";

interface IEmployeesCounterYears {
  [key: string]: {
    [key: number]: boolean;
  };
}

export const getYearsCountersForEmployees = (absences: TnAAbsenceDTO[]): EmployeesAndYears[] => {
  const res: IEmployeesCounterYears = {};

  absences.forEach((abs) => {
    const employeeId = abs.employee?.id;

    if (!employeeId) return;

    if (!res[employeeId]) {
      const absenceFrom = abs.fromDate?.year as number;
      const absenceTo = abs.toDate?.year as number;

      res[employeeId] = {
        [absenceFrom]: true,
        [absenceTo]: true,
      };
    } else {
      const absenceFrom = abs.fromDate?.year as number;
      const absenceTo = abs.toDate?.year as number;

      res[employeeId] = {
        ...res[employeeId],
        [absenceFrom]: true,
        [absenceTo]: true,
      };
    }
  });

  return Object.keys(res).map((el) => {
    return {
      employeeId: el,
      years: Object.keys(res[el]).map((el) => Number(el)),
    } as EmployeesAndYears;
  });
};

export const getCountersPerEmployee = (counters: TnACounterDTO[]): ICountersPerEmployee => {
  const res: ICountersPerEmployee = {};

  counters.forEach((counter) => {
    const employeeId = counter.employee?.id;

    if (!employeeId) return;

    if (!res[employeeId]) {
      res[employeeId] = [counter];
    } else {
      res[employeeId].push(counter);
    }
  });

  return res;
};

export const getOverlappingAbsences = (overlappingAbs: OverlappingAbsenceDTO[]): IOverlappingAbsences => {
  const res: IOverlappingAbsences = {};

  overlappingAbs.forEach((_abs) => {
    const absId = _abs.absence?.id;

    if (!absId) return;

    res[absId] = _abs;
  });

  return res;
};
